<template>
  <div class="login-container">
    <!-- Fondo decorativo -->
    <div class="login-background">
      <div class="bg-pattern">
        <section class="decoration-images">
          <img src="/img/login/SEÑALIZACIÓN.webp" alt="" class="decorative-image image-signage" />
          <img src="/img/login/OSO.webp" alt="" class="decorative-image image-bear" />
          <img src="/img/login/EDIFICIO.webp" alt="" class="decorative-image image-building" />
        </section>
      </div>
    </div>

    <!-- Contenido principal -->
    <div class="login-content">
      <!-- Logos corporativos -->
      <div class="login-header">
        <div class="logos-container">
          <img src="/img/logos/logo_american_school_way.webp" alt="American School Way" class="logo-asw">
          <div class="logo-divider"></div>
          <img src="/img/logos/logo_blocks_rojo_azul.png" alt="ASW Blocks" class="logo-blocks">
        </div>
        <h2 class="login-title">Portal de Estudiantes</h2>
      </div>

      <!-- Tarjeta de login -->
      <div class="login-card">
        <!-- Ícono de usuario -->
        <div class="user-icon-container">
          <div class="user-icon-circle">
            <i class="ri-user-line"></i>
          </div>
        </div>

        <!-- Título del formulario -->
        <div class="form-header">
          <h3 class="form-title">Bienvenido</h3>
          <p class="form-subtitle">Ingresa tus credenciales para continuar</p>
        </div>

        <!-- Formulario -->
        <div class="form-container">
          <user-form
            :isLogin="true"
            :user="user"
            btnText="Ingresar"
            v-on:processUserForm="processLogin($event)"
          ></user-form>
        </div>

        <!-- Footer de la tarjeta -->
        <div class="card-footer">
          <p class="footer-text">
            ¿Necesitas ayuda? 
            <a href="https://www.americanschoolway.edu.co/opiniones" target="_blank" class="footer-link">
              Contáctanos
            </a>
          </p>
        </div>
      </div>

      <!-- Copyright -->
      <div class="login-footer">
        <p>&copy; {{ new Date().getFullYear() }} American School Way. Todos los derechos reservados.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import UserForm from "./UserForm";
  export default {
    components: {UserForm},
    name: 'login',
    data () {
      return {
        user: {
          email: '',
          password: '',
          manetner_sesion:0
        },
      }
    },
    methods: {
      ...mapActions({
        login: 'auth/login',
        verificarAceptacionTerminos: 'academico/verificarAceptacionTerminos',
        verificarMensajes: 'auth/verificarMensajes',
        fetchTipos: 'academico/fetchTipos', //
        fetchSedeActual:'academico/fetchSedeActual', //
        fetchBanners: 'banner/fetchBanners', //
        fetchCursoActual: 'academico/fetchCursoActual', //
        fetchSedes: 'sedes/fetchLista',
      }),
      processLogin (user) {
        this.login({
          email: user.email,
          password: user.password,
          manetner_sesion: user.manetner_sesion
        }).then(
          user => {
            this.$router.push('/');
            this.verificarAceptacionTerminos()
            this.verificarMensajes()
            this.fetchTipos()
            this.fetchSedes()
            this.fetchCursoActual()
            this.fetchSedeActual()
            this.fetchBanners()
            .then((result)=>{
              if(result && result.length>0){
                // App.vue decide cuándo mostrarlo (espera si hay un recorrido u otro aviso en pantalla)
                this.$root.$emit('request-banner-display')
              }
            })        

          },
        )
      }
    }
  }
</script>

<style scoped>
/* Container Principal */
.login-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 1rem;
}

/* Fondo Azul Degradado */
.login-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--app-primary-blue) 0%, #005a9e 50%, var(--app-primary-blue) 100%);
  z-index: 0;
}

.bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(30deg, rgba(255, 255, 255, 0.05) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.05)),
    linear-gradient(150deg, rgba(255, 255, 255, 0.05) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.05)),
    linear-gradient(30deg, rgba(255, 255, 255, 0.05) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.05)),
    linear-gradient(150deg, rgba(255, 255, 255, 0.05) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.05));
  background-size: 80px 140px;
  background-position: 0 0, 0 0, 40px 70px, 40px 70px;
  opacity: 0.8;
}

/* Contenido Principal */
.login-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

/* Header con logos */
.login-header {
  text-align: center;
  margin-bottom: 2rem;
  width: 100%;
}

.logos-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.logo-asw {
  height: 35px;
  width: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  transition: all 0.3s ease;
}

.logo-asw:hover {
  transform: scale(1.05);
}

.logo-divider {
  width: 2px;
  height: 40px;
  background: linear-gradient(180deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
}

.logo-blocks {
  height: 50px;
  width: auto;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.logo-blocks:hover {
  transform: scale(1.05);
}

.login-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.5px;
}

/* Tarjeta de Login */
.login-card {
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(30px);
  border-radius: 24px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  overflow: visible;
  position: relative;
}

/* Ícono de usuario */
.user-icon-container {
  display: flex;
  justify-content: center;
  margin-top: -50px;
  margin-bottom: 1rem;
}

.user-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--app-primary-blue) 0%, #005a9e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 10px 30px rgba(13, 78, 140, 0.4),
    0 0 0 6px rgba(255, 255, 255, 0.95),
    0 0 0 8px rgba(13, 78, 140, 0.1);
  color: white;
  animation: pulse-icon 2s ease-in-out infinite;
}

.user-icon-circle svg {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

@keyframes pulse-icon {
  0%, 100% {
    transform: scale(1);
    box-shadow: 
      0 10px 30px rgba(13, 78, 140, 0.4),
      0 0 0 6px rgba(255, 255, 255, 0.95),
      0 0 0 8px rgba(13, 78, 140, 0.1);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 
      0 12px 35px rgba(13, 78, 140, 0.5),
      0 0 0 6px rgba(255, 255, 255, 0.95),
      0 0 0 8px rgba(13, 78, 140, 0.2);
  }
}

/* Header del formulario */
.form-header {
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 1rem;
}

.form-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: -0.5px;
}

.form-subtitle {
  margin: 0;
  font-size: 1rem;
  color: #6b6b8c;
  font-weight: 400;
}

/* Container del formulario */
.form-container {
  padding: 0 2rem;
}

/* Footer de la tarjeta */
.card-footer {
  margin-top: 1rem;
  padding: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
}

.footer-text {
  margin: 0;
  font-size: 0.9rem;
  color: #6b6b8c;
}

.footer-link {
  color: var(--app-primary-blue);
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}

.footer-link:hover {
  color: var(--app-primary-blue);
  text-decoration: underline;
}

/* Footer del login */
.login-footer {
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
}

.login-footer p {
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Elementos decorativos laterales con imágenes */
.decorative-element {
  position: fixed;
  z-index: 1;
  pointer-events: none;
}

.left-element {
  left: -14%;
  bottom: 0;
  display: flex;
  align-items: center;
}

.right-element {
  right: 2%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}


/* Señalización - Ocupa altura de pantalla */
.image-signage {
  height: 85vh;
  max-height: 900px;
  width: auto;
  position: absolute;
  left: -260px;
  bottom: 0;
}

/* Edificio - Ocupa altura de pantalla */
.image-building {
  height: 85vh;
  max-height: 900px;
  width: auto;
  position: absolute;
  right: -260px;
  bottom: 0;
  z-index: 0;
}

/* Oso - Más pequeño, a la izquierda del edificio */
.image-bear {
  height: 50vh;
  width: auto;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}


@media (max-width: 768px) {
  .image-signage, .image-building{
    height: 65vh;
  }

  .image-bear {
    height: 30vh;
  }
}

@media (max-width: 480px) {

  .logo-asw, .logo-blocks {
    height: 25px;
  }

  .login-title {
    font-size: 1.5rem;
  }

  .user-icon-circle {
    width: 70px;
    height: 70px;
  }

  .user-icon-circle svg {
    width: 36px;
    height: 36px;
  }

  .form-title {
    font-size: 1.35rem;
  }

  .form-subtitle {
    font-size: 0.85rem;
  }

  .form-container,
  .card-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .card-footer {
    margin-top: 1.5rem;
    padding-top: 1rem;
  }

  .footer-text {
    font-size: 0.85rem;
  }

  .login-footer {
    font-size: 0.8rem;
  }

  .bg-circle.circle-1 {
    width: 250px;
    height: 250px;
  }

  .bg-circle.circle-2 {
    width: 400px;
    height: 400px;
  }

  .bg-circle.circle-3 {
    width: 200px;
    height: 200px;
  }
}

/* Mejoras de accesibilidad */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
